export * from '@tools/components/fullscreen/public-api';
